export default "__VITE_ASSET__KxDR97G8__"